import React, { useState } from 'react';
import { X, CheckCircle, Loader2, MessageSquare, Percent } from 'lucide-react';
import styles from './Loans.module.css';
import toast from 'react-hot-toast';
import api from '../../../api/axios';

const LoanApprovalModal = ({ isOpen, onClose, loanId, onApproved }) => {
  const [formData, setFormData] = useState({
    interest_rate: '0',
    approval_remarks: ''
  });
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!loanId) return;

    const rate = parseFloat(formData.interest_rate);
    if (isNaN(rate) || rate < 0 || rate > 100) {
      toast.error('Interest rate must be between 0% and 100%');
      return;
    }

    setLoading(true);
    try {
      await api.post(`/loans/${loanId}/approve`, {
        interest_rate: rate,
        approval_remarks: formData.approval_remarks
      });
      toast.success('Loan approved successfully');
      onApproved();
      onClose();
    } catch (error) {
      console.error('Error approving loan:', error);
      toast.error(error.response?.data?.message || 'Failed to approve loan');
    } finally {
      setLoading(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className={styles['modal-backdrop']} onClick={onClose}>
      <div className={styles['modal-container']} onClick={e => e.stopPropagation()}>
        <div className={styles['modal-header']}>
          <div className={styles['modal-title-group']}>
            <h2>Approve Loan Request</h2>
            <p>Define loan interest parameters and record remarks.</p>
          </div>
          <button 
            className={styles['close-icon-btn']} 
            onClick={onClose} 
            style={{ background: 'none', border: 'none', cursor: 'pointer' }}
          >
            <X size={20} />
          </button>
        </div>

        <form onSubmit={handleSubmit}>
          <div className={styles['modal-body']}>
            {/* Interest Rate */}
            <div className={styles['form-group']}>
              <label><Percent size={16} /> Interest Rate (%) *</label>
              <input 
                type="number" 
                className={styles['form-input']}
                placeholder="e.g. 0 for interest-free, 5 for 5% APR"
                value={formData.interest_rate}
                onChange={(e) => setFormData({ ...formData, interest_rate: e.target.value })}
                step="0.01"
                min="0"
                max="100"
              />
            </div>

            {/* Approval Remarks */}
            <div className={styles['form-group']} style={{ marginTop: '20px' }}>
              <label><MessageSquare size={16} /> Approval Remarks</label>
              <textarea 
                className={styles['form-input']}
                style={{ minHeight: '100px', resize: 'vertical' }}
                placeholder="Write any approval notes or special instructions..."
                value={formData.approval_remarks}
                onChange={(e) => setFormData({ ...formData, approval_remarks: e.target.value })}
              />
            </div>
          </div>

          <div className={styles['modal-footer']}>
            <button type="button" className={styles['cancel-btn']} onClick={onClose} style={{ maxWidth: '120px' }}>
              Cancel
            </button>
            <button type="submit" className={styles['save-btn']} disabled={loading} style={{ maxWidth: '180px' }}>
              {loading ? <Loader2 size={18} className="spinner" /> : <CheckCircle size={18} />}
              <span>Approve Loan</span>
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default LoanApprovalModal;
